import React from 'react';

import { Link } from 'react-router-dom';

import { useLogo } from '../../logoContext';


import TowerImage from '../../asset/images/hotel/ferris-wheel.svg';
import forwardIcon from '../../asset/images/icons/forward-icon.svg';

import logo from '../../asset/images/logos/snb-logo-1.png';
import strip from '../../asset/images/strip.svg'
import rightIcon from '../../asset/images/icons/right-arrow-green.png'

import { useGuestStore } from '../../App';

const TransportationPage = () => {
  
  document.title = 'Transportation | SNB';

  const logoSrc = useLogo();

  const phone = useGuestStore((state) => state.phone)

  return (
    <div className='outer-wrapper'>
      <div className='container-fluid main-content'>
        <div className='row header'>
          <Link style={{ width: 'fit-content' }} to="/"><img className='ms-sm-3 ms-0' id='logo' src={logoSrc} alt='snb logo' /></Link>
          <h2 className='text-primary header-text'>2025 | SNB Nexus</h2>
        </div>

        <div className='px-4'>

          <div className="row nav">
            <div className="d-flex justify-content-end">
              <Link to="/home" className="text-decoration-none text-white">
                <button className="btn nav-btn d-flex align-items-center">
                  <img src={forwardIcon} alt="" width="22%" className="me-auto" /> <span>Back</span>
                </button>
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2 col-12">
              <h2 type="button" className="text-primary text-bold text-start pb-3">
                Transportation
              </h2>
            </div>

            <div className='col-lg-8 col-12'>
              <div className="row d-flex justify-content-center mb-3">

                  {/* Mr Talal */}
                {phone === '0553005853'
                &&
                <div className="col-md-8 col-12 mb-2">
                  <div className="border border-2 border-success pb-2 shadow">
                    <h4 className="text-white text-center bg-primary ps-3 py-2">
                      Mercedes-Benz S-Class
                    </h4>
                    <h4 className="text-primary mobile d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />Driver:&nbsp;<b>Nicolae Marin</b>
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Car Number:&nbsp;<b>M777NYK</b>
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Tel:&nbsp;<a href='tel:+447553661477'><b>+44 755 3661477</b></a>
                    </h4>
                  </div>
                </div>
                }
               
               {/* Mr. Yazeed */}
                {phone === '0554244460'
                &&
                <div className="col-md-8 col-12 mb-2">
                  <div className="border border-2 border-success pb-2 shadow">
                    <h4 className="text-white text-center bg-primary ps-3 py-2">
                      Mercedes-Benz S-Class
                    </h4>
                    <h4 className="text-primary mobile d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />Driver:&nbsp;<b>Ciprian Apostol</b>
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Car Number:&nbsp;<b>LY23UXL</b></h4>
                      
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Tel:&nbsp;<a className='text-primary' href='tel:+447898599909'><b>+44 789 8599909</b></a></h4>

                  </div>
                </div>
                }

               {/* Mr. Saeed Al Ghamdi */}
                {phone === '0555401887'
                &&
                <div className="col-md-8 col-12 mb-2">
                  <div className="border border-2 border-success pb-2 shadow">
                    <h4 className="text-white text-center bg-primary ps-3 py-2">
                      Mercedes-Benz S-Class
                    </h4>
                    <h4 className="text-primary mobile d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />Driver:&nbsp;<b>Hafiz Sobaan Khalid</b>
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Car Number:&nbsp;<b>PO23WXV</b></h4>
                    
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Tel:&nbsp;<a className='text-primary' href='tel:+447305415362'><b>+44 730 5415362</b></a></h4>
                  </div>
                </div>
                }

                 {/* Mr. Nadir Al Badrani */}

                {phone === '0552700000'
                &&
                <div className="col-md-8 col-12 mb-2">
                  <div className="border border-2 border-success pb-2 shadow">
                    <h4 className="text-white text-center bg-primary ps-3 py-2">
                      Mercedes-Benz S-Class
                    </h4>
                    <h4 className="text-primary mobile d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />Driver:&nbsp;<b>Hafiz Sobaan Khalid</b>
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Car Number:&nbsp;<b>PO23WXV</b></h4>
                      <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" /> Tel:&nbsp;<a className='text-primary' href='tel:+447305415362'><b>+44 730 5415362</b></a></h4>
                  </div>
                </div>
                }
                
                {phone !== '0553005853' && phone !== '0554244460'&& phone !== '0555401887' && phone !== '0552700000'
                &&
                <div className="col-md-8 col-12 mb-2">
                  <div className="border border-2 border-success pb-2 shadow">
                    <h4 className="text-white text-center bg-primary ps-3 py-2">
                      Transportation is arranged
                    </h4>
                    <h4 className="text-primary mobile d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />From Airport to Hotel
                    </h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />From Hotel to Apollo’s Muse (Bacchanalia) & back to Hotel</h4>
                    <h4 className="text-primary email d-flex align-items-center">
                      <img src={rightIcon} className='me-2' height={'20px'} alt="right-arrow" />From Hotel to Airport</h4>
                  </div>
                </div>
                }


              </div>
            </div>

          </div>
        </div>

      </div>
      <span className='footer'>
        <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-none d-md-block wheel-small p-absolute" />
        <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-block d-md-none wheel-small" />
        <h2 className='text-primary footer-text mx-0 ps-0 mx-md-4 ps-md-3' >SNB Nexus 2026
</h2>
        <img className='strip' src={strip} alt='footer' />
      </span>
    </div>
  );
};

export default TransportationPage;

